module.exports = __webpack_public_path__ + "img/btn-arrow-right.794e1a2c.svg";